import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../Styles/Gallery.css";
import api from "../Api.js";
import ImageLightbox from "./Helping Component/ImageZoom.jsx";

const Gallery = () => {
  const [imageData, setImageData] = useState([]);
  const [open, setOpen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const { id } = useParams();

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await api.get(`/hotels/${id}`);
        if (response.data.status === true) {
          setImageData(response?.data?.data?.images);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchImages();
  }, []);

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">Photo Gallery</h2>

      <div className="gallery-grid">
        {imageData?.map((src, index) => (
          <div key={index} className="gallery-item">
            <img
              src={src.image}
              alt={`Gallery ${index}`}
              onClick={() => {
                setStartIndex(index);  // IMPORTANT
                setOpen(true);
              }}
              className="gallery-img"
            />
          </div>
        ))}
      </div>

      {/* 🔥 Lightbox Viewer */}
      <ImageLightbox
        open={open}
        setOpen={setOpen}
        images={imageData.map((img) => img.image)}
        startIndex={startIndex}
      />
    </div>
  );
};

export default Gallery;
